module.exports = __webpack_public_path__ + "static/Footpad_v2-80131e69c9fb3e4ea64fbee6974d93c4.jpg";